import { InMemoryCache } from '@apollo/client';

import { possibleTypes } from '@occc/graphql';

export const cache = new InMemoryCache({
  possibleTypes,
  typePolicies: {
    User: {
      keyFields: ['uuid'],
    },
    Audience: {
      keyFields: ['uuid'],
    },
    Campaign: {
      keyFields: ['uuid'],
    },
    OpenCommerceUser: {
      keyFields: ['uuid'],
    },
    Location: {
      keyFields: ['uuid'],
    },
    LocationGroup: {
      keyFields: ['uuid'],
    },
    SteeringWallet: {
      keyFields: ['uuid'],
    },
    PointExpirationScheduleNode: {
      keyFields: ['date'],
    },
    SegmentUploadFile: {
      keyFields: ['uuid'],
    },
    WalletSteeringSurvey: {
      keyFields: ['uuid'],
    },
    Referral: {
      keyFields: ['receiverId'],
    },
    SiteIssue: {
      keyFields: ['uuid'],
    },
    AudienceBroadcastMessage: {
      keyFields: ['uuid'],
    },
    ExternalLineItemPromotion: {
      // Don't normalize - treat each instance as unique
      // This prevents Apollo from deduplicating items with empty IDs
      keyFields: false,
    },
    TriggeredMessage: {
      keyFields: ['uuid'],
    },
  },
});
